<template>
  <div class="hideTotal">
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="当日交易费用查询"
        name="transactionCostInquiry"
      >
        <!-- 搜索 -->
        <!-- <table-search
          label-width="65px"
          @search="fetchList(1)"
          @reset="handleReset"
        >
          <template v-slot:basic>
            <el-form-item label="组织">
              <el-select
                v-model="query.marketId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </template>
        </table-search> -->
        <!-- 导出 -->
        <inquery-result isTips @export="toDownload" />
        <!-- 表格 -->
        <el-table :data="tableData">
          <el-table-column
            fixed
            label="序号"
            align="center"
            width="70px"
          >
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column>
          <af-table-column
            fixed
            prop="transDate"
            label="日期"
          />
          <af-table-column
            fixed
            prop="varietyName"
            label="品种名称"
          />
          <af-table-column
            fixed
            prop="businessAmount"
            label="交易量"
          />
          <af-table-column
            prop="intraDayAmount"
            label="当开当平量"
          />
          <af-table-column
            prop="overnightAmount"
            label="非当开当平量"
          />
          <af-table-column
            prop="fee"
            label="软件使用费"
          />
          <af-table-column
            prop="intraDayDiscountFee"
            label="日返"
          />
          <af-table-column
            prop="overnightDiscountFee"
            label="月返"
          />
          <af-table-column
            prop="totalMReturnScaleAmount"
            label="比例返"
          />
          <af-table-column
            prop="free"
            label="信息服务费"
          />
        </el-table>
        <el-pagination
          class="pagination"
          layout="total, prev, pager, next"
          :current-page.sync="currentNo"
          :total="total"
          background
          @current-change="changePage"
        />
      </el-tab-pane>
      <el-tab-pane
        label="历史交易费用查询"
        name="historicalTransactionCostInquiry"
      >
        <historicalTransactionCostInquiry />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import historicalTransactionCostInquiry from './historical-transaction-cost-inquiry'
import api from '@/api'

function Query () {
  this.marketId = '000' // 组织编号
}
export default {
  name: 'TransactionCostInquiry',
  components: {
    historicalTransactionCostInquiry
  },
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      marketId: '',
      activeName: 'transactionCostInquiry', // tab生效

      param: {},
      nowTime: {}, // 交易日，即当天，需要冲接口拿
    }
  },
  mounted () {
    this.SelTradeDate()
  },
  methods: {
    // 分页查询
    fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        isTradeDay: 0, // 当日
        startTime: this.nowTime.strCurrentTradeDay,
        endTime: this.nowTime.strCurrentTradeDay,
      }
      this.param = param
      api.spotPurchaseSaleInquiry.TransactionCostInquiry(param).then(res => {
        this.total = res.data.totalElements
        this.tableData = res.data.rows
        this.marketId = this.query.marketId
      })
    },
    SelTradeDate () {
      let param = {
        marketId: '000' // 沐甜市场
      }
      api.spotPurchaseSaleInquiry.SelTradeDate(param).then(res => {
        this.nowTime = res.data
        this.fetchList(1)
      })
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    open (row) {
      this.row = row
      this.isShow = true
    },
    // 关闭弹窗
    shutDown () {
      this.isShow = false
    },
    // 导出
    toDownload () {
      let param = {
        ...this.param,
        tableUser: this.$store.state.user.name,
        tableName: '当日交易费用',
        excelParentPath: 'fund',
        excelPath: 'tradeReport',
        marketId: this.marketId,
        currentNo: 1,
        pageSize: 2000,
        exportKeyMap: [{
          fieldLabel: '日期',
          excelColumn: 'transDate'
        },
        {
          fieldLabel: '品种名称',
          excelColumn: 'varietyName'
        },
        {
          fieldLabel: '交易量',
          excelColumn: 'businessAmount'
        },
        {
          fieldLabel: '当开当平量',
          excelColumn: 'intraDayAmount'
        },
        {
          fieldLabel: '非当开当平量',
          excelColumn: 'overnightAmount'
        },
        {
          fieldLabel: '软件使用费',
          excelColumn: 'fee'
        },
        {
          fieldLabel: '日返',
          excelColumn: 'intraDayDiscountFee'
        },
        {
          fieldLabel: '月返',
          excelColumn: 'overnightDiscountFee'
        },
        {
          fieldLabel: '比例返',
          excelColumn: 'totalMReturnScaleAmount'
        },
        {
          fieldLabel: '信息服务费',
          excelColumn: 'free'
        },
        ]
      }
      this.$utils.getExcelFile(this, api.exportExcelData, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },

  }
}

</script>
<style lang="scss" scoped>
  // 按钮对齐搜索框
  ::v-deep .table-page-search-submitButtons {
    margin-left: 100px
  }

</style>
